module.exports = __webpack_public_path__ + "img/bull.bd2d3e75.svg";